import { useEffect, useRef, useState } from 'react'
import {
    View,
    Text,
    TextInput,
    Pressable,
    FlatList,
    Keyboard,
    Platform,
    TouchableWithoutFeedback,
    ScrollView,
} from 'react-native'
import { Image } from 'expo-image'
import theme from '../../../theme'
import NetInfo from '@react-native-community/netinfo'
import { Feather, Ionicons } from '@expo/vector-icons'
import { request_send_message_doti } from '@/services/doti.services'
import { getAuthToken, withOpacity } from '@/utils/functions.utils'
import { LoadingDots } from '../customUtils/LoadingDots'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { UserAvatarMobile } from '../web/UserAvatarWeb'
import { getLocation } from '../appBar/context/LocationContext'
import {
    addMessages,
    getMessages,
    clearMessages,
    saveSuggestedQuestions,
    getSuggestedQuestions,
} from '../../../db-sqlite/repositories/doti.repository'
import {
    SafeKeyboardController,
    SafeKeyboardAvoidingView,
    useSafeKeyboardOpen,
} from '../../../SafeKeyboardProvider'
import { DotiItemChat } from './DotiChatCards'
import { mapSuggestedQuestions } from './mappers/doti.mappers'
import { resetCache } from '../../utils/FetchServices'
import { generalFontSize, generalLineHeigth } from './constants/doti.constants'
import { SafeBottomSpace } from '../customUtils/SafeBottomSpace'

const suggestionsExample = [
    '¿Cuáles son mis tiendas más cercanas?',
    '¿Cómo solicito vacaciones?',
    '¿Cuáles son mis puntos fuertes?',
]

let sessionInitialized = false

export const DotiChatScreen = ({ route }) => {
    const [question, setQuestion] = useState('')
    const inputRef = useRef(null)
    const [messages, setMessages] = useState([])
    const [sessionID, setSessionID] = useState(null)
    const [loader, setLoader] = useState(false)
    const isSendingRef = useRef(false)
    const listRef = useRef(null)
    const insets = useSafeAreaInsets()
    const gotWelcomeMsg = useRef(false)
    const { userLat, userLng } = getLocation()
    const userName = route?.params?.userName || ''
    const [hasConnection, setHasConnection] = useState(true)

    const isKeyboardOpen = useSafeKeyboardOpen()
    const [suggestedQuestions, setSuggestedQuestions] = useState([])
    const [extraMsg, setExtraMsg] = useState('')

    async function loadChat() {
        try {
            if (sessionInitialized) {
                const storedMessages = await getMessages()
                if (storedMessages.length > 0) {
                    await addMultipleMessages(storedMessages, true)
                    const storedSuggestions = await getSuggestedQuestions()
                    if (storedSuggestions.length > 0) {
                        setSuggestedQuestions(storedSuggestions)
                    }
                    gotWelcomeMsg.current = true
                    return
                }
            }

            await clearMessages()
            sessionInitialized = true
            sendQuestion('', true)
        } catch (error) {
            console.error('Error loading chat history:', error)
            sendQuestion('', true)
        }
    }

    useEffect(() => {
        if (gotWelcomeMsg.current) return
        loadChat()
    }, [])

    async function sendQuestion(text, welcome = false) {
        SafeKeyboardController.dismiss()
        console.log(
            'sendQuestion called with text:',
            text,
            'welcome:',
            welcome,
            'isSendingRef:',
            isSendingRef.current,
            'hasConnection:',
            hasConnection,
        )
        if (isSendingRef.current === true) return
        isSendingRef.current = true
        setExtraMsg('')
        if (text != '') {
            addMessage(text, 'text')

            addMessages([
                {
                    role: 'user',
                    content: text,
                    timestamp: new Date().toISOString(),
                    type: 'text',
                    values: [],
                },
            ])
        }

        try {
            setLoader(true)
            const netInfoState = await NetInfo.fetch()
            if (
                netInfoState.isConnected === false ||
                netInfoState.isInternetReachable === false
            ) {
                setHasConnection(false)
                setExtraMsg(
                    'No puedo responder ahora mismo, revisa tu conexión e intenta nuevamente',
                )
                removeMessage(text)
                return
            }
            setHasConnection(true)
            if (text != '') {
                addMessages([
                    {
                        role: 'user',
                        content: text,
                        timestamp: new Date().toISOString(),
                        type: 'text',
                        values: [],
                    },
                ])
            }
            const authToken = await getAuthToken()
            let data = await request_send_message_doti({
                authToken,
                question: text,
                sessionID,
                userLat,
                userLng,
            })

            // console.log('DATA ==>', JSON.stringify(data))
            resetCache()
            if (!data || data.status === -1 || !data.single) {
                console.log('Error in response data:', data)
                removeMessage(text || '')
                setExtraMsg(
                    'Lo siento, tuve un pequeño error 😅 Intentá nuevamente en unos minutos.',
                )
                return
            }

            let single = data.single
            if (single?.session_id) {
                setSessionID(single.session_id)
            }

            if (
                single.suggested_questions &&
                single.suggested_questions.length > 0
            ) {
                const suggested = mapSuggestedQuestions(single.suggested_questions)
                setSuggestedQuestions(suggested)
                saveSuggestedQuestions(suggested)
            } else if (welcome) {
                setSuggestedQuestions(suggestionsExample)
                saveSuggestedQuestions(suggestionsExample)
            }

            const messages = single.messages || []
            console.log('MEnsajes Lenght', messages.length)
            if (messages.length > 0) {
                setLoader(false)

                await addMessages(messages)
                await addMultipleMessages(messages, true)
                if (welcome) gotWelcomeMsg.current = true
            }
            if (single.content && Object.keys(single.content).length > 0) {
                const data = single.content
                setLoader(false)
                await addMessages([
                    {
                        role: 'assistant',
                        content: data.content,
                        timestamp: new Date().toISOString(),
                        type: 'text',
                        values: [],
                    },
                ])
                console.log('Agrego mensaje de content. No deberia ser historial')
                addMessage(data.content, 'text', true)
                if (welcome) gotWelcomeMsg.current = true
            }
            isSendingRef.current = false
        } catch (e) {
            isSendingRef.current = false
            console.log('Error Sending Message ==> ', e)
            if (text != '') removeMessage(text)
            setLoader(false)
        } finally {
            isSendingRef.current = false
            setLoader(false)
        }
    }
    async function addMultipleMessages(messages, isHistory) {
        let mappedMessages = messages.map((m) => {
            return {
                content: m.content,
                type: 'text',
                doti: m.role !== 'user',
                date: formatDotiDate(m.timestamp || ''),
                isHistory: isHistory,
            }
        })
        setMessages((prev) => [...prev, ...mappedMessages])
    }

    function addMessage(content, type, isDoti = false, date = new Date()) {
        let newMessage = {
            content: content,
            type: type,
            doti: isDoti,
            date: formatDotiDate(date),
        }
        setMessages((prev) => [...prev, newMessage])

        if (!isDoti) setQuestion('')
        if (isDoti) scrollToBottom()
    }

    function removeMessage(content) {
        setMessages((prev) => prev.filter((item) => item.content !== content))
        setQuestion(content)
    }
    const disableSend = !question || question.trim() === '' || loader

    function scrollToBottom() {
        if (!listRef.current) return
        setTimeout(() => {
            listRef.current?.scrollToOffset({ offset: 0, animated: true })
        }, 500)
    }
    const finalData = [...messages].reverse()
    const lastHistoryIndex =
        messages.length > 0
            ? findFirstIndex(finalData, (i) => i.isHistory === true)
            : -1
    return (
        <SafeKeyboardAvoidingView
            style={{ flex: 1, backgroundColor: '#F1F2FF' }}
            behavior='padding'
        >
            <FlatList
                ref={listRef}
                data={finalData}
                inverted
                style={{ flex: 1 }}
                keyboardDismissMode='on-drag'
                keyboardShouldPersistTaps='handled'
                windowSize={100}
                ItemSeparatorComponent={() => <View style={{ height: 16 }} />}
                renderItem={({ item, index }) => {
                    const realIndex = index

                    const isLastHistory = lastHistoryIndex === realIndex
                    return (
                        <Pressable onPress={Keyboard.dismiss}>
                            <DotiMessage
                                type={item.type}
                                content={item.content}
                                isDoti={item.doti}
                                date={item.date}
                                userName={userName}
                            />
                            <View
                                style={{
                                    flex: 1,
                                    marginHorizontal: 30,
                                    backgroundColor: isLastHistory
                                        ? theme.colors.lightGray
                                        : undefined,
                                    height: isLastHistory ? 1 : 0,
                                    marginTop: isLastHistory ? 8 : 0,
                                }}
                            />
                        </Pressable>
                    )
                }}
                ListHeaderComponent={() => {
                    return (
                        <View
                            style={{
                                marginVertical: 10,
                            }}
                        >
                            <DotiExtraMessage
                                isThinking={loader}
                                noConnection={!hasConnection}
                                canRetry={question != ''}
                                retry={() => {
                                    sendQuestion(question)
                                }}
                                message={extraMsg}
                            />
                        </View>
                    )
                }}
                ListFooterComponent={() => <View style={{ height: 12 }} />}
                onContentSizeChange={() => {
                    //Para que cuando aparezca el loader, vaya al fondo de la lista
                    if (loader) {
                        scrollToBottom()
                    }
                }}
            />

            {suggestedQuestions.length > 0 && !loader && (
                <ScrollView
                    horizontal
                    showsHorizontalScrollIndicator={false}
                    keyboardShouldPersistTaps='handled'
                    style={{ flexGrow: 0 }}
                    contentContainerStyle={{
                        paddingHorizontal: 16,
                        paddingTop: 6,
                        paddingBottom: 4,
                        gap: 6,
                    }}
                >
                    {suggestedQuestions.map((q, index) => (
                        <Pressable
                            key={index}
                            onPress={() => sendQuestion(q)}
                            style={{
                                backgroundColor: withOpacity(
                                    theme.colors.colorPrimary,
                                    0.12,
                                ),
                                borderRadius: 16,
                                paddingHorizontal: 10,
                                paddingVertical: 5,
                                maxWidth: '70%',
                            }}
                        >
                            <Text
                                style={{
                                    color: theme.colors.textPrimary,
                                    fontSize: 14,
                                    lineHeight: 20,
                                }}
                                numberOfLines={2}
                            >
                                {q}
                            </Text>
                        </Pressable>
                    ))}
                </ScrollView>
            )}

            <View
                style={{
                    width: '100%',
                    flexDirection: 'row',
                    paddingHorizontal: 16,
                    marginTop: 8,
                    alignItems: 'center',
                }}
            >
                <TextInput
                    ref={inputRef}
                    multiline
                    value={question}
                    onChangeText={setQuestion}
                    placeholder={'Enviar mensaje a Doti...'}
                    placeholderTextColor={theme.colors.darkGray}
                    style={{
                        flex: 1,
                        minHeight: 40,
                        maxHeight: 120,
                        borderRadius: 25,
                        paddingStart: 12,
                        paddingEnd: 47,
                        paddingVertical: 12,
                        fontSize: 16,
                        backgroundColor: 'white',
                        color: theme.colors.textPrimary,
                    }}
                    maxLength={500}
                    returnKeyType='default'
                />

                <Pressable
                    style={[
                        {
                            borderRadius: 20,
                            position: 'absolute',
                            right: 20,
                        },
                    ]}
                    onPress={() => sendQuestion(question)}
                    disabled={disableSend}
                >
                    <Ionicons
                        name='arrow-up-circle'
                        color={
                            !disableSend
                                ? theme.colors.colorPrimary
                                : withOpacity(theme.colors.colorPrimary, 0.2)
                        }
                        size={35}
                    />
                </Pressable>
            </View>
            <SafeBottomSpace />
        </SafeKeyboardAvoidingView>
    )
}

const defaultMessage = {
    type: 'text',
    content: 'Hola, soy Doti. ¿Con que te puedo ayudar hoy?',
    doti: true,
    date: formatDotiDate(new Date()),
}
const defaultMessage2 = {
    type: 'text',
    content: 'Hola,?',
    doti: false,
    date: formatDotiDate(new Date()),
}

export const DotiMessage = ({
    type,
    content,
    isDoti,
    date = null,
    userName = '',
}) => {
    const styleParentDoti = {
        alignSelf: 'flex-start',
        marginHorizontal: 0,
    }
    const styleParentYou = {
        alignSelf: 'flex-end',
        marginEnd: 10,
    }
    const styleDoti = {
        alignSelf: 'flex-start',
        backgroundColor: undefined,
        marginStart: 0,
    }
    const styleYou = {
        alignSelf: 'flex-end',
        backgroundColor: withOpacity(theme.colors.colorPrimary, 0.12),
        marginEnd: 8,
        flexShrink: 1,
    }
    const name = isDoti ? 'Doti' : userName
    return (
        <View style={[{ flex: 1, width: '100%' }]}>
            <View
                style={[
                    {
                        maxWidth: !isDoti ? '77%' : '100%',
                        flexDirection: 'row',
                        flexShrink: 1,
                    },
                    isDoti ? styleParentDoti : styleParentYou,
                ]}
            >
                <View
                    style={[
                        {
                            minWidth: 30,
                            height: 'auto',
                            borderRadius: 10,
                            paddingHorizontal: 12,
                            paddingVertical: 10,
                        },
                        isDoti ? styleDoti : styleYou,
                    ]}
                >
                    {name && name != '' && (
                        <Text
                            style={{
                                fontSize: 16,
                                color: theme.colors.textPrimary,
                                fontWeight: '700',
                                marginBottom: 4,
                                textAlign: isDoti ? 'left' : 'right',
                            }}
                        >
                            {name}
                            {!isDoti && (
                                <Text style={{ fontWeight: '400' }}>{' (Tú)'}</Text>
                            )}
                            {date && (
                                <Text
                                    style={{
                                        color: theme.colors.darkGray,
                                        fontSize: 16,
                                        fontWeight: '400',
                                        marginBottom: 8,
                                        textAlign: isDoti ? 'left' : 'right',
                                    }}
                                >
                                    {' ' + date}
                                </Text>
                            )}
                        </Text>
                    )}

                    {(() => {
                        const segments = parseDotiMessage(content)
                        const hasCards = segments.some((s) => s.type === 'card')
                        if (!hasCards) {
                            return (
                                <Text
                                    style={{
                                        color: theme.colors.textPrimary,
                                        fontSize: 16,
                                        textAlign: isDoti ? 'left' : 'left',
                                        lineHeight: 24,
                                    }}
                                    selectable
                                >
                                    {content}
                                </Text>
                            )
                        }
                        return renderMessageSegments(segments, {
                            color: theme.colors.textPrimary,
                            fontSize: generalFontSize,
                            textAlign: isDoti ? 'left' : 'left',
                            lineHeight: generalLineHeigth,
                        })
                    })()}
                </View>
                {!isDoti && (
                    <UserAvatarMobile
                        style={{
                            width: 28,
                            height: 28,
                            backgroundColor: 'white',
                            borderRadius: 30,
                        }}
                        contentFit='contain'
                    />
                )}
            </View>
        </View>
    )
}

export function formatDotiDate(date) {
    if (!date || date === '') return ''

    const d = new Date(date)

    const hoy = new Date()
    const esHoy =
        d.getDate() === hoy.getDate() &&
        d.getMonth() === hoy.getMonth() &&
        d.getFullYear() === hoy.getFullYear()

    const hh = d.getHours().toString().padStart(2, '0')
    const mm = d.getMinutes().toString().padStart(2, '0')

    if (esHoy) {
        return `${hh}:${mm}`
    }

    const dd = d.getDate().toString().padStart(2, '0')
    const mmMonth = (d.getMonth() + 1).toString().padStart(2, '0')

    return `${dd}/${mmMonth} ${hh}:${mm}`
}

export const DotiExtraMessage = ({
    isThinking = false,
    noConnection = false,
    canRetry = false,
    retry = () => {},
    message = '',
}) => {
    if (!isThinking && !noConnection && message === '') return <></>
    return (
        <View
            style={[
                {
                    height: 'auto',
                    borderRadius: 10,
                    paddingHorizontal: 16,
                    paddingVertical: 10,
                },
                {
                    backgroundColor: 'white',
                    flexDirection: 'row',
                    flexShrink: 1,
                    marginHorizontal: 16,
                    alignSelf: 'flex-start',
                },
            ]}
        >
            <View style={{ flex: message !== '' || noConnection ? 1 : undefined }}>
                {isThinking && (
                    <LoadingDots
                        style={{
                            marginBottom: message != '' ? 12 : 0,
                            justifyContent: 'flex-start',
                        }}
                        dotStyle={{ width: 8, height: 8 }}
                    />
                )}

                {message != '' && (
                    <>
                        <Text
                            style={{
                                fontSize: generalFontSize,
                                lineHeight: generalLineHeigth,
                                color: theme.colors.textPrimary,
                                marginEnd: 12,
                            }}
                        >
                            {message}
                        </Text>
                        <Pressable onPress={() => retry()}>
                            <Text
                                style={{
                                    marginTop: 4,
                                    fontWeight: '700',
                                    fontSize: 14,
                                    color: theme.colors.colorPrimary,
                                }}
                            >
                                Reintentar
                            </Text>
                        </Pressable>
                    </>
                )}
            </View>

            {noConnection && (
                <Image
                    source={require('../../../assets/doti/doti_no_connection.png')}
                    style={{
                        width: 60,
                        height: 60,
                        alignSelf: 'center',
                    }}
                    contentFit='contain'
                />
            )}
        </View>
    )
}

function findFirstIndex(arr, predicate) {
    for (let i = 0; i < arr.length; i++) {
        if (predicate(arr[i], i, arr)) return i
    }
    return -1
}

/**
 * Parsea un mensaje de Doti separando texto plano de bloques de cards.
 * Los bloques están delimitados por ####=> y <=####.
 * @param {string} text - El content del mensaje
 * @returns {Array<{type: 'text'|'card', content: string|object}>}
 */
export function parseDotiMessage(text) {
    if (!text || typeof text !== 'string')
        return [{ type: 'text', content: text || '' }]

    const segments = []
    const regex = /####=>([\s\S]*?)<=####/g
    let lastIndex = 0
    let match

    while ((match = regex.exec(text)) !== null) {
        // Text before this card block
        const before = text.slice(lastIndex, match.index).trim()
        if (before) {
            segments.push({ type: 'text', content: before })
        }

        // Card block
        const jsonStr = match[1].trim()
        try {
            const parsed = JSON.parse(jsonStr)
            segments.push({ type: 'card', content: parsed })
        } catch {
            // Invalid JSON — treat as plain text
            segments.push({ type: 'text', content: jsonStr })
        }

        lastIndex = match.index + match[0].length
    }

    // Remaining text after last block
    const remaining = text.slice(lastIndex).trim()
    if (remaining) {
        segments.push({ type: 'text', content: remaining })
    }

    // If nothing was parsed (no delimiters found, but text was all whitespace), return original
    if (segments.length === 0) {
        return [{ type: 'text', content: text }]
    }

    return segments
}

/**
 * Renderiza los segmentos parseados como componentes React Native.
 * @param {Array<{type: 'text'|'card', content: string|object}>} segments
 * @param {object} textStyle - Estilo para los segmentos de texto
 * @returns {React.ReactNode[]}
 */
export function renderMessageSegments(segments, textStyle) {
    return segments.map((segment, index) => {
        if (segment.type === 'text') {
            return (
                <Text key={index} style={textStyle} selectable>
                    {segment.content}
                </Text>
            )
        }

        if (segment.type === 'card') {
            return (
                <View key={index} style={{ marginVertical: 24 }}>
                    <DotiItemChat item={segment.content} listView={true} />
                </View>
            )
        }

        return null
    })
}
